import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createHigherOrderComponent, useDebounce } from '@wordpress/compose';
import { speak } from '@wordpress/a11y';
/**
 * A Higher Order Component used to be provide speak and debounced speak
 * functions.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-a11y/#speak
 *
 * @param {WPComponent} Component The component to be wrapped.
 *
 * @return {WPComponent} The wrapped component.
 */

export default createHigherOrderComponent(function (Component) {
  return function (props) {
    return createElement(Component, _extends({}, props, {
      speak: speak,
      debouncedSpeak: useDebounce(speak, 500)
    }));
  };
}, 'withSpokenMessages');
//# sourceMappingURL=index.js.map